import type { QueryClient } from '@tanstack/react-query';
import type { Me } from '@pickpro/contracts';
import { getSessionGeneration, isCurrentSession } from '../api/session-generation';
import { resetLiveSocket } from '../live/live-socket-state';
import { mirrorPreferences } from './mirror-preferences';

export const ME_QUERY_KEY = ['me'] as const;
export const PRIVATE_QUERY_META = { session: 'private' } as const;

export const replaceSessionCache = async (
  client: QueryClient,
  user: Me | null,
  generation: number,
): Promise<void> => {
  if (!isCurrentSession(generation)) return;
  await client.cancelQueries({
    predicate: (query) =>
      query.queryKey[0] === ME_QUERY_KEY[0] || query.meta?.['session'] === 'private',
  });
  if (!isCurrentSession(generation)) return;
  client.setQueryData(ME_QUERY_KEY, user);
  client.removeQueries({ predicate: (query) => query.meta?.['session'] === 'private' });
  if (user) mirrorPreferences(user.settings);
};

export const clearSessionCache = (
  client: QueryClient,
  generation = getSessionGeneration(),
): Promise<void> => {
  resetLiveSocket();
  return replaceSessionCache(client, null, generation);
};
